import styled, { css } from 'styled-components';

export const Mosaic = styled.div(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 1fr;
    gap: ${theme.sz.s05};

    @media (max-width: ${theme.sz.md}) {
      grid-template-columns: repeat(2, 1fr);
    }
  `,
);

export const Tile = styled.div(
  () => css`
    overflow: hidden;
  `,
);

export const TileVideo = styled.video(
  () => css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Same bias as the session screen: keep faces out of the crop */
    object-position: center 25%;
  `,
);

// Purple wash that pulls the grid back so the panel copy reads over it.
export const Tint = styled.div(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    background-color: ${theme.co.tertiary0};
    opacity: 0.8;
  `,
);
